import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/codebuild/output/src2184593401/src/src/templates/markdown-page.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>Terms and conditions applicable to all .us registrations</h1>
    <p>
  <a href="/terms-conditions">Back to Terms and Conditions</a>
    </p>
    <p>
  <strong>1. INFORMATION.</strong>
    </p>
    <blockquote>
  <p>
    (a) You, the Customer, will provide to Namescout.com accurate and reliable
    contact details and promptly correct and update such details during the term
    of the .US TLD domain name registration, including: your full name, postal
    address, e-mail address, voice telephone number, fax number if available,
    and if you are an organization, association, or corporation, the name of an
    authorized person for contact purposes. In addition, you will provide to
    Namescout.com, and will promptly correct and update, the IP address and
    corresponding names of the primary nameserver and secondary nameserver(s)
    for the .US TLD domain name which is being registered (the “Registered
    Name”).
  </p>
  <p>
    (b) You hereby acknowledge and agree that your willful or grossly negligent
    provision of inaccurate or unreliable information, or your willful or
    grossly negligent failure to promptly update information provided to
    Namescout.com shall constitute a material breach of your agreement with
    Namescout.com and be a basis for cancellation of the Registered Name.
  </p>
    </blockquote>
    <p>
  <strong>2. ENFORCEMENT OF ACCURATE WHOIS DATA.</strong>
    </p>
    <blockquote>
  <p>
    (a) Namescout.com will investigate written complaints from third parties
    regarding false and/or inaccurate Whois data of Customers. If Namescout.com
    determines that your information is false, inaccurate or not up to date,
    Namescout.com will notify you via e-mail that your Whois record may be
    false, inaccurate or not up to date.
  </p>
  <p>
    (b) You will be required to update your contact information no later than
    thirty (30) calendar days from the date of such notice. If, within thirty
    (30) days, you can either (i) show that you have not provided false or
    inaccurate contact information or (ii) provide the updated Whois
    information, then you will be allowed to maintain your Registered Name. If,
    however, after thirty (30) days, you do not respond to Namescout.com’s
    notice or are unable to provide true and accurate contact information, you
    will be deemed to have breached the registration agreement and Namescout.com
    will be required to delete the registration.
  </p>
  <p>
    (c) Namescout.com shall not be required to refund any fees paid by you if
    Namescout.com terminates your registration agreement due to its enforcement
    of this provision
  </p>
    </blockquote>
    <p>
  <strong>3. ENFORCEMENT LICENSING USE OF REGISTERED NAME. </strong>
    </p>
    <blockquote>
  <p>
    (a) You hereby acknowledge and agree that if you license use of your
    Registered Name to a third party you nonetheless remain the registrant of
    record and are responsible for providing your own full contact information
    and for providing and updating accurate technical and administrative contact
    information adequate to facilitate timely resolution of any problems that
    arise in connection with the Registered Name. If you are licensing use of a
    Registered Name you hereby accept liability for harm caused by wrongful use
    of the Registered Name, unless you promptly disclose the identity of the
    licensee to the party providing reasonable evidence of actionable harm.
  </p>
    </blockquote>
    <p>
  <strong>4. NO INFRINGEMENT AND DISPUTE RESOLUTION.</strong>
    </p>
    <blockquote>
  <p>
    (a) You hereby represent that, to the best of your knowledge and belief,
    neither the registration of the Registered Name nor the manner in which it
    is directly or indirectly used infringes the legal rights of any third
    party.
  </p>
  <p>
    (b) For the adjudication of disputes concerning or arising from use of a
    Registered Name, you hereby agree and covenant to submit, without prejudice
    to other potentially applicable jurisdictions, to the jurisdiction of the
    courts (1) of your domicile, (2) where Namescout.com located, and 3) the
    United States.
  </p>
    </blockquote>
    <p>
  <strong>5. REGISTRATION SUBJECT TO POLICIES AND PROCEDURES.</strong>
    </p>
    <blockquote>
  <p>
    (a) You hereby acknowledge and agree that your registration of the
    Registered Name is subject to suspension, cancellation, or transfer pursuant
    to any specification or policy adopted by the registry of .US TLDs, Neustar,
    Inc., (the “Registry”), or pursuant to any Namescout.com procedure not
    inconsistent with a Registry adopted specification or policy, (1) to correct
    mistakes by Namescout.com or the Registry in registering the name or (2) for
    the resolution of disputes concerning the Registered Name.
  </p>
  <p>
    (b) You hereby acknowledge and agree that the Registry reserves the right to
    deny, cancel or transfer any registration that it deems necessary, in its
    discretion (i) to protect the integrity and stability of the registry; (ii)
    to comply with all applicable laws, government rules or requirements,
    requests of law enforcement, in compliance with any dispute resolution
    process; (iii) to avoid any liability, civil or criminal, on the part of the
    Registry as well as its affiliates, subsidiaries, officers, directors,
    representatives, employees, and stockholders; (iv) for violations of the
    terms and conditions herein; or (v) to correct mistakes made by the Registry
    or any registrar in connection with a domain name registration. The Registry
    also reserves the right to freeze a Registered Name during resolution of a
    dispute.
  </p>
  <p>
    (c) You hereby agree to comply with all standards, policies, procedures and
    practices respecting the .US TLD established by the Registry, the United
    States Department of Commerce (“DoC”), the usTLD Policy Council and ICANN
    (including without limitation ICANN policies pertaining to open country code
    TLDs).
  </p>
    </blockquote>
    <p>
  <strong>6. INDEMNIFICATION.</strong>
    </p>
    <blockquote>
  <p>
    (a) You hereby agree to indemnify and hold harmless the Registry and its
    directors, officers, employees, representatives, agents, affiliates, and
    stockholders from and against any and all claims, suits, actions, other
    proceedings, damages, liabilities, costs and expenses of any kind, including
    without limitation reasonable legal fees and expenses, arising out of or
    relating to your (i) domain name registration and (ii) use of any Registered
    Name.
  </p>
    </blockquote>
    <p><strong>7. NEXUS REQUIREMENTS.</strong></p>
    <blockquote>
      <p>(a) You hereby certify that you meet the following requirements (the “Nexus Requirements”) to qualify to register to use a Registered Name:</p>
      <blockquote>
  <p>
    (i) The listed nameservers provided pursuant to Section 1 above are located
    within the United States of America; and
  </p>
  <p>(ii) You are either: </p>
  <blockquote>
    <p>
      (A) A natural person (i) who is a citizen or permanent resident of the
      United States of America or any of its possessions or territories, or (ii)
      whose primary place of domicile is in the United States of America or any
      of its possessions, or
    </p>
    <p>
      (B) An entity or organization that is (i) incorporated within one of the
      fifty (50) U.S. states, the District of Columbia, or any of the United
      States possessions or territories or (ii) organized or otherwise
      constituted under the laws of a state of the United States of America, the
      District of Columbia or any of its possessions or territories, or
    </p>
    <p>
      (C) An entity or organization (including a federal, state, or local
      government of the United States, or a political subdivision thereof) that
      has a bona fide presence in the United States.
    </p>
  </blockquote>
      </blockquote>
      <p>(b) You hereby acknowledge and agree that your failure to abide by the Nexus Requirements shall be a basis for cancellation of the Registered Name.</p>
      <p>(c) You hereby agree and acknowledge that any dispute as to whether Nexus Requirements have been met shall be subject to the Nexus Dispute Policy of the Registry, the current version of which may be found at <a href="http://www.neustar.us/policies/" target="_blank">http://www.neustar.us/policies/</a>. The registry reserves the right to modify the Nexus Dispute Policy at any time, and revisions will be posted at least 30 days before such revisions become effective.</p>
    </blockquote>
    <p>
  <a href="/terms-conditions">Back to Terms and Conditions</a>
    </p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      